import "./ui.css";

interface AppIconProps {
  name: string | null | undefined;
  packageId?: string | null;
  size?: number;
  className?: string;
}

const COLOR_POOL = [
  { bg: "#0f5b6e", light: false },
  { bg: "#a8341d", light: false },
  { bg: "#1c6b3a", light: false },
  { bg: "#8b6a18", light: false },
  { bg: "#2e3a8c", light: false },
  { bg: "#6f3e8a", light: false },
  { bg: "#b5511e", light: false },
  { bg: "#1c1c19", light: false },
];

function pickColor(key: string): { bg: string; light: boolean } {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0;
  }
  return COLOR_POOL[Math.abs(hash) % COLOR_POOL.length];
}

function glyphFor(name: string | null | undefined, packageId?: string | null): string {
  const source = (name?.trim() || packageId?.split(".").pop() || "?").toUpperCase();
  return source.slice(0, 2);
}

export function AppIcon({ name, packageId, size = 32, className = "" }: AppIconProps) {
  const key = (packageId || name || "?").toString();
  const palette = pickColor(key);
  const textColor = palette.light ? "#1c1c19" : "#f6f5f1";
  return (
    <div
      className={`app-icon ${className}`}
      style={{
        background: palette.bg,
        color: textColor,
        width: size,
        height: size,
        fontSize: size > 36 ? 16 : 13,
      }}
      aria-hidden="true"
    >
      {glyphFor(name, packageId)}
    </div>
  );
}
